module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-black.99e8ad5d.png";